import React, { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const QuestBox: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="QuestBox"
      illustration={
        <svg xmlns="http://www.w3.org/2000/svg" width={restProps?.width ?? "32"} height={restProps?.height ?? "30"} viewBox="0 0 32 30" fill="none" {...props}>
          <g clip-path="url(#clip0_42603_3182)">
            <path d="M1.224 24.5447V5.10022C1.224 2.59566 3.29181 0.564697 5.84179 0.564697H26.0562C28.6062 0.564697 30.674 2.59566 30.674 5.10022V24.7359C30.674 26.5028 29.2089 27.9235 27.41 27.8871C21.7537 27.7778 10.1814 27.5683 4.50653 27.6867C2.70763 27.7232 1.224 26.3024 1.224 24.5356V24.5447Z" fill="#D548EC" stroke="black" stroke-miterlimit="10"/>
            <path d="M30.674 9.78137H21.661C21.1603 9.78137 20.7059 9.51725 20.4463 9.0801L19.1852 6.93073C18.9255 6.49357 18.4619 6.22035 17.9704 6.22035H14.6787C14.2521 6.22035 13.8441 6.42071 13.5752 6.7668L11.6372 9.24403C11.3683 9.59011 10.9603 9.79048 10.5338 9.79048H1.224V4.72673C1.224 2.35878 3.17126 0.455322 5.57288 0.455322L26.3715 0.473537C28.7731 0.473537 30.7204 2.39521 30.7111 4.76315L30.6833 9.78137H30.674Z" fill="#D548EC" stroke="black" stroke-miterlimit="10"/>
            <path d="M16.6723 9.78813L19.2408 12.7481C19.6488 13.2125 19.3057 13.932 18.6844 13.932H13.5567C12.9354 13.932 12.5923 13.2125 13.0003 12.7481L15.5688 9.78813C15.8656 9.45116 16.3941 9.45116 16.6815 9.78813H16.6723Z" fill="#8FF7F2"/>
            <path d="M0.510038 23.7614C0.510038 23.5064 0.72331 23.306 0.982945 23.306H7.956C8.41963 23.306 8.86472 23.0692 9.1429 22.6776L10.5709 20.6557C10.8491 20.2641 11.2849 20.0273 11.7485 20.0273C14.2151 20.0273 17.5069 19.9818 20.0012 19.9727C20.4648 19.9727 20.9099 20.2003 21.1881 20.6011L22.6532 22.6776C22.9314 23.0783 23.3672 23.306 23.8401 23.306H31.0542C31.3139 23.306 31.5271 23.5155 31.5271 23.7705V26.8215C31.5271 28.3242 30.2939 29.5446 28.7732 29.5446H3.21766C1.68767 29.5446 0.454402 28.306 0.463675 26.7942L0.510038 23.7523V23.7614Z" fill="#B263FD" stroke="black" stroke-miterlimit="10"/>
          </g>
          <defs>
            <clipPath id="clip0_42603_3182">
              <rect width="32" height="30" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default QuestBox;
